export default __webpack_public_path__ + "static/media/boombox.e2541b6d.png";